module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      " + _vm._s(_vm.datasetTypeDisplayName) + "\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.datasetTypeDisplayName))])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "action-button pull-right"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    attrs: {
      "id": "file-upload",
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.onImportClick
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.columns,
      "rows": _vm.auditDataSet,
      "totalRows": _vm.auditDataSetCount,
      "pagination-options": {
        enabled: true,
        perPage: 15,
        perPageDropdown: [10, 15, 20, 50, 100]
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'importedAt') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                      ")]) : (props.column.field == 'audit') ? _c('span', [_c('router-link', {
          attrs: {
            "to": ("audit/" + (props.row.id))
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1) : (props.column.field == 'evaluate') ? _c('span', [_c('router-link', {
          attrs: {
            "to": ("evaluate/" + (props.row.id))
          }
        }, [_c('i', {
          staticClass: "fa fa-calculator",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1) : (props.column.field == 'export') ? _c('span', {
          attrs: {
            "id": "download-link"
          },
          on: {
            "click": function($event) {
              return _vm.exportDataSet(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : (props.column.field == 'delete') ? _c('span', {
          attrs: {
            "id": "delete-link"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteDatasetModel(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-database",
      "title": "No datasets found",
      "hint": "Import a dataset to start auditing, or change the filters."
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1), _vm._v(" "), (_vm.isGenderSplitModel) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "translate"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "260px",
      "max-width": "600px"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Apply sampling on data set (Optional)")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 20px",
      "font-size": "18px",
      "text-align": "justify"
    }
  }, [_vm._t("body", function() {
    return [_c('div', [_vm._v("Are you interested in applying gender-based sampling to the uploaded data? This can aid in downstream data analysis and lead to improved evaluation.")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeGenderSplitModel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showSplitSelectModel
    }
  }, [_vm._v("Choose sampling")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.uploadFileData
    }
  }, [_vm._v("Skip & Import Dataset")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isSplitSelectModel) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "translate"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "260px",
      "max-width": "600px"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Select sampling percentage")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 20px",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "height": "100%",
      "font-size": "20px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticStyle: {
        "margin-bottom": "10px",
        "font-size": "18px"
      }
    }, [_vm._t("body", function() {
      return [_c('div', [_vm._v("Please choose the percentage split between gender by using slider:")])]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {}, [_c('label', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "for": "inputRange"
      }
    }, [_c('span', [_vm._v("Women: " + _vm._s(_vm.slideInput) + "%")]), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("Men: " + _vm._s(100 - _vm.slideInput) + "%")])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.slideInput),
        expression: "slideInput"
      }],
      staticClass: "form-control-range",
      attrs: {
        "type": "range",
        "id": "slideInput",
        "max": "100",
        "min": "0"
      },
      domProps: {
        "value": (_vm.slideInput)
      },
      on: {
        "__r": function($event) {
          _vm.slideInput = $event.target.value
        }
      }
    })])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSplitSelectModel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showGenderSplitModel
    }
  }, [_vm._v("Go to previous step")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFileData(_vm.slideInput)
      }
    }
  }, [_vm._v("Import Dataset")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isDeleteDatasetModel) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "translate"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "200px",
      "max-width": "600px"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Delete Dataset")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 20px",
      "font-size": "18px",
      "text-align": "justify"
    }
  }, [_vm._t("body", function() {
    return [_c('div', [_vm._v("Are you sure you want to permanently delete the dataset?")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeDeleteDatasetModel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteDataSet
    }
  }, [_vm._v("Delete")])])])])])]) : _vm._e()])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "custom-file-upload",
    attrs: {
      "for": "file-upload"
    }
  }, [_c('p', {
    staticClass: "btn btn-primary btn-import-dataset"
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Import Dataset")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-332341e2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auditing/index.vue
// module id = aXLg
// module chunks = 1